import React from 'react';
import styles from '../../../styles/UserManagement.module.css';
import sidePanelStyles from '../../../styles/SidePanel.module.css';

interface PermissionGroupsSelectorProps {
    isEditingMainAdmin: boolean;
    loading: boolean;
    permissionGroups: any[];
    selectedGroups: string[];
    onToggle: (groupId: string) => void;
}

const PermissionGroupsSelector: React.FC<PermissionGroupsSelectorProps> = ({
    isEditingMainAdmin,
    loading,
    permissionGroups,
    selectedGroups,
    onToggle
}) => {
    if (isEditingMainAdmin) {
        return (
            <div className={sidePanelStyles.formGroup}>
                <label className={sidePanelStyles.formLabel}>
                    Permission Groups
                </label>
                <div className={styles.permissionInfoMessage} style={{ color: 'var(--warning-dark)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                    <span>Main administrator always has "Top Level Access" and cannot be modified. This ensures system security and prevents accidental permission removal.</span>
                </div>
            </div>
        );
    }

    return (
        <div className={sidePanelStyles.formGroup}>
            <label className={sidePanelStyles.formLabel}>
                Permission Groups
            </label>

            {loading ? (
                <div className={styles.permissionsContent}>
                    <div className={styles.permissionsGrid}>
                        {[120, 140, 100, 160, 130, 110].map((width, index) => (
                            <div
                                key={index}
                                className={styles.permissionButtonSkeleton}
                                style={{ width: `${width}px` }}
                            ></div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className={styles.permissionsContent}>
                    {permissionGroups.length > 0 ? (
                        <div className={styles.permissionsGrid}>
                            {permissionGroups.map((group: any) => {
                                const isSelected = selectedGroups.includes(group.id);
                                return (
                                    <button
                                        key={group.id}
                                        type="button"
                                        className={`${styles.permissionButton} ${isSelected ? styles.permissionButtonActive : ''}`}
                                        onClick={() => onToggle(group.id)}
                                    >
                                        {group.name}
                                    </button>
                                );
                            })}
                        </div>
                    ) : (
                        <div className={styles.noPermissionsFound}>
                            <p>No permission groups available</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PermissionGroupsSelector;
